"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHash = exports.decryptAndVerifySignature = exports.decryptMessage = exports.decryptPGPKey = exports.decryptWithWalletRPCMethod = exports.encryptWithRPCEncryptionPublicKeyReturnRawData = exports.getPublicKey = void 0;
const tslib_1 = require("tslib");
const metamaskSigUtil = require("@metamask/eth-sig-util");
const eth_sig_util_1 = require("@metamask/eth-sig-util");
const CryptoJS = require("crypto-js");
const ethers_1 = require("ethers");
const helpers_1 = require("../chat/helpers");
const address_1 = require("./address");
const getPublicKey = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { account, signer } = options || {};
    const address = account || (yield (signer === null || signer === void 0 ? void 0 : signer.getAddress())) || '';
    console.log('Fetching Public Key');
    const metamaskProvider = new ethers_1.ethers.providers.Web3Provider(window.ethereum);
    const web3Provider = (signer === null || signer === void 0 ? void 0 : signer.provider) || metamaskProvider;
    const keyB64 = yield web3Provider.provider.request({
        method: "eth_getEncryptionPublicKey",
        params: [address]
    });
    console.log(`Public Key: ${keyB64}`);
    return keyB64;
});
exports.getPublicKey = getPublicKey;
const encryptWithRPCEncryptionPublicKeyReturnRawData = (text, encryptionPublicKey) => {
    const encryptedSecret = metamaskSigUtil.encrypt({
        publicKey: encryptionPublicKey,
        data: text,
        version: 'x25519-xsalsa20-poly1305'
    });
    return encryptedSecret;
};
exports.encryptWithRPCEncryptionPublicKeyReturnRawData = encryptWithRPCEncryptionPublicKeyReturnRawData;
const decryptWithWalletRPCMethod = (encryptedPGPPrivateKey, account) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    console.warn("decryptWithWalletRPCMethod method is DEPRECATED. Use decryptPGPKey method with signer!");
    return yield (0, exports.decryptPGPKey)({
        encryptedPGPPrivateKey,
        account
    });
});
exports.decryptWithWalletRPCMethod = decryptWithWalletRPCMethod;
const decryptPGPKey = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { encryptedPGPPrivateKey, account = null, signer = null } = options || {};
    try {
        if (account == null && signer == null) {
            throw new Error(`At least one from account or signer is necessary!`);
        }
        const wallet = (0, helpers_1.getWallet)({ account, signer });
        const address = yield (0, helpers_1.getAccountAddress)(wallet);
        if (!(0, address_1.isValidETHAddress)(address)) {
            throw new Error(`Invalid address!`);
        }
        let decryptedMsg;
        if ((_a = wallet === null || wallet === void 0 ? void 0 : wallet.signer) === null || _a === void 0 ? void 0 : _a.privateKey) {
            decryptedMsg = (0, eth_sig_util_1.decrypt)({
                encryptedData: JSON.parse(encryptedPGPPrivateKey),
                privateKey: (_b = wallet === null || wallet === void 0 ? void 0 : wallet.signer) === null || _b === void 0 ? void 0 : _b.privateKey.substring(2),
            });
        }
        else {
            const metamaskProvider = new ethers_1.ethers.providers.Web3Provider(window.ethereum);
            const web3Provider = (signer === null || signer === void 0 ? void 0 : signer.provider) || metamaskProvider;
            decryptedMsg = yield web3Provider.provider.request({
                method: "eth_decrypt",
                params: [encryptedPGPPrivateKey, address]
            });
        }
        return decryptedMsg;
    }
    catch (err) {
        console.error(`[Push SDK] - API  - Error - API decrypt Pgp Key() -:  `, err);
        throw Error(`[Push SDK] - API  - Error - API decrypt Pgp Key() -: ${err}`);
    }
});
exports.decryptPGPKey = decryptPGPKey;
const decryptMessage = ({ encryptedPGPPrivateKey, encryptionType, encryptedSecret, pgpPrivateKey, signature, signatureValidationPubliKey }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let plainText;
    if (encryptionType !== 'PlainText' && encryptionType !== null) {
        plainText = yield (0, exports.decryptAndVerifySignature)({
            cipherText: encryptedPGPPrivateKey,
            encryptedSecretKey: encryptedSecret,
            privateKeyArmored: pgpPrivateKey,
            publicKeyArmored: signatureValidationPubliKey,
            signatureArmored: signature,
        });
    }
    else {
        plainText = encryptedPGPPrivateKey;
    }
    return plainText;
});
exports.decryptMessage = decryptMessage;
const decryptAndVerifySignature = ({ cipherText, encryptedSecretKey, publicKeyArmored, signatureArmored, privateKeyArmored }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    // const privateKeyArmored: string = await DIDHelper.decrypt(JSON.parse(encryptedPrivateKeyArmored), did)
    const secretKey = yield (0, helpers_1.pgpDecrypt)({
        cipherText: encryptedSecretKey,
        toPrivateKeyArmored: privateKeyArmored
    });
    yield (0, helpers_1.verifySignature)({ messageContent: cipherText, signatureArmored, publicKeyArmored });
    return (0, helpers_1.aesDecrypt)({ cipherText, secretKey });
});
exports.decryptAndVerifySignature = decryptAndVerifySignature;
const generateHash = (message) => {
    const hash = CryptoJS.SHA256(JSON.stringify(message)).toString(CryptoJS.enc.Hex);
    return hash;
};
exports.generateHash = generateHash;
//# sourceMappingURL=crypto.js.map